import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/Introduction/Missions.css";

const IntroductionCard = {
    borderRadius: "20px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
}

const IntroductionCardHeader = {
    fontFamily: "IranSans",
    color: "#174561",
    fontSize: "1.1em",
    paddingRight: "10px",
    paddingTop: "3px"
}
const MissStatement = props => {

    return props.size === "laptopdesktop" ? (
        <div style={{ backgroundColor: "#ffffff" }}>
            <Row>
                <Col span={4}></Col>
                <Col span={16}>
                    <div style={IntroductionCard}>
                        <Margin top={5}></Margin>
                        <Row>
                            <Col span={16}>
                                <div style={{ backgroundColor: "#f5f5f5", height: "100%", borderRadius: "20px 0 0 20px", padding: "30px" }}>
                                    <p className="textParagraphTablet">
                                        • تمام همکاران سعی و کوشش خود را در جهت شکوفایی و سرآمدی استعدادهای خود و قابلیت، شایستگی‌ها و ظرفیت هلدینگ، بکار خواهند بست.
                                        <br/>
                                        • پیشتازی در ارائه خدمات متمایز، خیرخواهی برای تمام ذی‌نفعان و ایفای نقش محوری در حوزه‌های مختلف کاری از ارزش های هلدینگ است.
                                        <br />
                                        • ویژگی‌های همکاران؛ صداقت و صمیمیت، تعهد و تخصص، امانت‌داری و وفای به عهد، مسئولیت پذیری و پاسخ گویی، خلاقیت، اعتماد به نفس و بلند همتی و رعایت انصاف و احترام می‌باشد. 
                                        <br />
                                        • اخلاق حرفه‌ای و رعایت چارچوب‌های فرهنگی و اسلامی، سرمشق تمامی همکاران در محیط کار می باشد.
                                        <br />
                                        • تمرکز هلدینگ بر نیازهای واقعی، ارائه خدمات صادقانه و محصولات کیفی و استفاده از روش‌های کارآمد و راهکارهای نوآور خواهد بود به طوری که شخصیت سازمانی قابل اعتمادی از خود در تعامل با ذی‌نفعان نشان دهد.
                                        <br />
                                        • ایجاد شرایط کاری سالم، بانشاط، حرفه‌ای و مناسب برای شکوفایی استعدادها و توانمندی‌ها و کمک به ارتقای کیفیت زندگی همکاران از تعهدات رهبران و مدیران هلدینگ می‌باشد.
                                        <br />
                                        • نیروهای انسانی در هر جایگاه سازمانی مهم ترین سرمایه های هلدینگ محسوب می شوند و هلدینگ در حفظ و توانمندسازی آن ها سرمایه گذاری می نماید.
                                        <br />
                                        • همکاران و پرسنل هلدینگ، تمام تلاش خود را برای تقویت روحیه همکاری و مشارکت در کارها بکار خواهند گرفت.
                                        <br />
                                        • همکاران و پرسنل هلدینگ، گیرندگان خدمات را ولی نعمت خود می داند و بنابراین تمام تلاش خود را بکار خواهند گرفت تا خدمات مورد انتظار آن ها را تدارک ببینند.
                                        <br />
                                        • هلدینگ خود را در کنار بیمه گران می داند و تلاش می شود تا این تعامل تقویت شود و توسعه پیدا کند.
                                    </p>
                                </div>
                            </Col>
                            <Col span={8} style={{ direction: "rtl", textAlign: "right" }}>
                                <div className="miniCardTitleBorder" style={{
                                    position: 'absolute', left: '50%', top: '50%',
                                    transform: 'translate(-50%, -50%)'
                                }}>
                                    <p className="miniCardTitle"><strong>بیانیه ماموریت</strong></p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={4}></Col>
            </Row>
        </div>
    ) : props.size === "tablet" ? (
            <div>
                <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                        <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                            <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px 20px 0 0" }}>
                                <Center>
                                    <Margin top={4}>
                                        <div>
                                            <p className="cardTitleTablet"><strong>بیانیه ماموریت</strong></p>
                                        </div>
                                    </Margin>
                                </Center>
                                <Center>
                                    <hr className="cardTitleHRTablet" />
                                </Center>
                                <Margin top={2}></Margin>
                                <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#fff" }}>
                                    <p className="textParagraphTablet" style={{ paddingTop: "10px" }}>
                                        • تمام همکاران سعی و کوشش خود را در جهت شکوفایی و سرآمدی استعدادهای خود و قابلیت، شایستگی‌ها و ظرفیت هلدینگ، بکار خواهند بست.
                                        <br />
                                        • پیشتازی در ارائه خدمات متمایز، خیرخواهی برای تمام ذی‌نفعان و ایفای نقش محوری در حوزه‌های مختلف کاری از ارزش های هلدینگ است.
                                        <br />
                                        • ویژگی‌های همکاران؛ صداقت و صمیمیت، تعهد و تخصص، امانت‌داری و وفای به عهد، مسئولیت پذیری و پاسخ گویی، خلاقیت، اعتماد به نفس و بلند همتی و رعایت انصاف و احترام می‌باشد.
                                        <br />
                                        • اخلاق حرفه‌ای و رعایت چارچوب‌های فرهنگی و اسلامی، سرمشق تمامی همکاران در محیط کار می باشد.
                                        <br />
                                        • تمرکز هلدینگ بر نیازهای واقعی، ارائه خدمات صادقانه و محصولات کیفی و استفاده از روش‌های کارآمد و راهکارهای نوآور خواهد بود به طوری که شخصیت سازمانی قابل اعتمادی از خود در تعامل با ذی‌نفعان نشان دهد.
                                        <br />
                                        • ایجاد شرایط کاری سالم، بانشاط، حرفه‌ای و مناسب برای شکوفایی استعدادها و توانمندی‌ها و کمک به ارتقای کیفیت زندگی همکاران از تعهدات رهبران و مدیران هلدینگ می‌باشد.
                                        <br />
                                        • نیروهای انسانی در هر جایگاه سازمانی مهم ترین سرمایه های هلدینگ محسوب می شوند و هلدینگ در حفظ و توانمندسازی آن ها سرمایه گذاری می نماید.
                                        <br />
                                        • همکاران و پرسنل هلدینگ، تمام تلاش خود را برای تقویت روحیه همکاری و مشارکت در کارها بکار خواهند گرفت.
                                        <br />
                                        • همکاران و پرسنل هلدینگ، گیرندگان خدمات را ولی نعمت خود می داند و بنابراین تمام تلاش خود را بکار خواهند گرفت تا خدمات مورد انتظار آن ها را تدارک ببینند.
                                        <br />
                                        • هلدینگ خود را در کنار بیمه گران می داند و تلاش می شود تا این تعامل تقویت شود و توسعه پیدا کند.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={2}></Col>
                </Row>
            </div>

    ) : (
                <div>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                                <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px 20px 0 0" }}>
                                    <Center>
                                        <Margin top={4}>
                                            <div>
                                                <p className="cardTitleMobile"><strong>بیانیه ماموریت</strong></p>
                                            </div>
                                        </Margin>
                                    </Center>
                                    <Center>
                                        <div className="cardTitleHR"></div>
                                    </Center>
                                    <Margin top={2}></Margin>
                                    <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#fff" }}>
                                        <p className="textParagraphMobile" style={{ paddingTop: "10px" }}>
                                            • تمام همکاران سعی و کوشش خود را در جهت شکوفایی و سرآمدی استعدادهای خود و قابلیت، شایستگی‌ها و ظرفیت هلدینگ، بکار خواهند بست.
                                        <br />
                                        • پیشتازی در ارائه خدمات متمایز، خیرخواهی برای تمام ذی‌نفعان و ایفای نقش محوری در حوزه‌های مختلف کاری از ارزش های هلدینگ است.
                                        <br />
                                        • ویژگی‌های همکاران؛ صداقت و صمیمیت، تعهد و تخصص، امانت‌داری و وفای به عهد، مسئولیت پذیری و پاسخ گویی، خلاقیت، اعتماد به نفس و بلند همتی و رعایت انصاف و احترام می‌باشد.
                                        <br />
                                        • اخلاق حرفه‌ای و رعایت چارچوب‌های فرهنگی و اسلامی، سرمشق تمامی همکاران در محیط کار می باشد.
                                        <br />
                                        • تمرکز هلدینگ بر نیازهای واقعی، ارائه خدمات صادقانه و محصولات کیفی و استفاده از روش‌های کارآمد و راهکارهای نوآور خواهد بود به طوری که شخصیت سازمانی قابل اعتمادی از خود در تعامل با ذی‌نفعان نشان دهد.
                                        <br />
                                        • ایجاد شرایط کاری سالم، بانشاط، حرفه‌ای و مناسب برای شکوفایی استعدادها و توانمندی‌ها و کمک به ارتقای کیفیت زندگی همکاران از تعهدات رهبران و مدیران هلدینگ می‌باشد.
                                        <br />
                                        • نیروهای انسانی در هر جایگاه سازمانی مهم ترین سرمایه های هلدینگ محسوب می شوند و هلدینگ در حفظ و توانمندسازی آن ها سرمایه گذاری می نماید.
                                        <br />
                                        • همکاران و پرسنل هلدینگ، تمام تلاش خود را برای تقویت روحیه همکاری و مشارکت در کارها بکار خواهند گرفت.
                                        <br />
                                        • همکاران و پرسنل هلدینگ، گیرندگان خدمات را ولی نعمت خود می داند و بنابراین تمام تلاش خود را بکار خواهند گرفت تا خدمات مورد انتظار آن ها را تدارک ببینند.
                                        <br />
                                        • هلدینگ خود را در کنار بیمه گران می داند و تلاش می شود تا این تعامل تقویت شود و توسعه پیدا کند.
                                    </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                </div>
            );
};

export default MissStatement;
